import React, { useEffect, useState } from 'react';
import { message, Modal, Button } from 'antd';
import { FiltersComponentAntd } from './NovedadesParticipanteFilter';
import NovedadViewModal from "./NovedadesParticipanteView"
import NovedadFormAntd from './NovedadesParticipanteForm';
import NovedadesTable from './NovedadesParticipanteTable';
import { createNovedad, deleteNovedad, updateNovedad, getDepartamentos, getMunicipios, getParticipantes, getAllNovedades, getParticipantesEditar } from '../../services/novedad_participante/novedadParticipanteService';
import { selectAppPermissions } from '../../store/auth/selectors';
import ExportExcelButton from './NovedadesExportable';
import { useSelector } from 'react-redux';

const NovedadesPage = () => {
  const [novedades, setNovedades] = useState([]);
  const [filteredNovedades, setFilteredNovedades] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [novedadEditando, setNovedadEditando] = useState(null);
  const [listaPartiEditar, setListaPartEditar] = useState(null);
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [participantes, setParticipantes] = useState([]);
  const [modalVisualizacion, setModalVisualizacion] = useState(false)
  const [novedadVisualizando, setNovedadVisualizando] = useState(null);
  const appName = 'novedad_participante';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const permissionDelete = permissions.priv_delete === 'Y';
  const permissionUpdate = permissions.priv_update === 'Y';
  const permissionInsert = permissions.priv_insert === 'Y';
  const permissionPrint = permissions.priv_print === 'Y';
  const permissionExport = permissions.priv_export === 'Y';
  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;

  const [filters, setFilters] = useState({
    texto: '',
    departamento: '0',
    municipio: '0',
    tipoNovedad: '0',
  });

  const [opcionesFiltros, setOpcionesFiltros] = useState({
    departamentos: [],
    municipios: [],
    tiposNovedad: [],
  });

  const fetchInitialData = async () => {
    try {
      const [dataNovedad, dataDepartamento, dataMunicipio] = await Promise.all([
        getAllNovedades(),
        getDepartamentos(),
        getMunicipios(),
      ]);
      setDepartamentos(dataDepartamento);
      setMunicipios(dataMunicipio);
      setNovedades(dataNovedad);
      setFilteredNovedades(dataNovedad);
      cargarOpciones(dataNovedad);
    } catch (error) {
      message.error('Error al cargar los datos iniciales');
    }
  };

  const fetchParticipantes = async () => {
    try {
      const data = await getParticipantes();
      setParticipantes(data);
    } catch (error) {
      message.error('Error al cargar los participantes');
    }
  };

  useEffect(() => {
    fetchInitialData();
    fetchParticipantes(); // carga inicial de participantes
  }, []);


  const participantesEditar = async (participanteId) => {
    try {
      const data = await getParticipantesEditar(participanteId);
      setListaPartEditar(data);
    } catch (error) {
      message.error("Error al cargar los participantes");
    }
  };

  const refreshNovedades = async () => {
    try {
      const data = await getAllNovedades();
      setNovedades(data);
      setFilteredNovedades(data);
      cargarOpciones(data); // Solo si tus filtros se basan en los datos de novedades
    } catch (error) {
      message.error("Error al recargar novedades");
    }
  };

  const cargarOpciones = (data) => {
    const departamentos = [...new Set(data.map((n) => n.departamento))];
    const municipios = [...new Set(data.map((n) => n.municipio))];
    const tiposNovedad = [...new Set(data.map((n) => n.tipo_novedad))];
    setOpcionesFiltros({ departamentos, municipios, tiposNovedad });
  };

  const aplicarFiltros = () => {
    let filtrados = [...novedades];
    const { texto, departamento, municipio, tipoNovedad } = filters;
    if (texto) {
      const lowerTexto = texto.toLowerCase();
      filtrados = filtrados.filter((n) => {
        const nombre = n.nombre_participante || "";
        const cedula = n.numero_identificacion || "";
        return (
          nombre.toLowerCase().includes(lowerTexto) ||
          cedula.toLowerCase().includes(lowerTexto)
        );
      });
    }


    if (departamento !== '0') {
      filtrados = filtrados.filter((n) => n.departamento === departamento);
    }

    if (municipio !== '0') {
      filtrados = filtrados.filter((n) => n.municipio === municipio);
    }

    if (tipoNovedad !== '0') {
      filtrados = filtrados.filter((n) => String(n.tipo_novedad) === tipoNovedad);
    }

    setFilteredNovedades(filtrados);
  };

  const onUpdateFilter = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const onLimpiarFiltros = () => {
    setFilters({
      texto: '',
      departamento: '0',
      municipio: '0',
      tipoNovedad: '0',
    });
  };

  const handleEliminar = async (novedad) => {
    if (!permissionDelete) return message.warning("No tienes permisos para eliminar");
    Modal.confirm({
      title: '¿Estás seguro que deseas eliminar esta novedad?',
      onOk: async () => {
        try {
          await deleteNovedad(novedad.oid, novedad, userLogin);
          message.success('Novedad eliminada correctamente');
          refreshNovedades();
        } catch (err) {
          console.error(err);
          message.error('Error al eliminar la novedad');
        }
      },
    });
  };

  const handleEditar = async (novedad) => {
    setNovedadEditando(novedad);
    await participantesEditar(novedad.participante_oid); // Espera antes de abrir
    setFormVisible(true);
  };

  const handleVisualizar = (novedad) => {
    setNovedadVisualizando({
      participante: novedad.nombre_participante,
      cedula: novedad.numero_identificacion,
      departamento: novedad.departamento,
      municipio: novedad.municipio,
      tipoNovedad: novedad.tipo_novedad,
      fechaRegistro: novedad.fecha_registro,
      observacion: novedad.observacion,
      estado: novedad.estado,
      reemplazo: novedad.reemplazo,
      estado_remplazo: novedad.estado_remplazo,
      nombre_reemplazo: novedad.nombre_reemplazo,
      soportes: novedad.soportes || [],
      soportes_reemplazo: novedad.soportesRemplazo || []
    });
    setModalVisualizacion(true);
  };

  const guardarNovedad = async (formData) => {
    try {
      const {
        participanteSeleccionado,
        tipoNovedad,
        observacion,
        participanteCedula,
        estado,
        fecha_registro,
        soportes,
        soportesReemplazo,
        participanteReemplazo,
        estado_remplazo
      } = formData;

      const data = new FormData();
      data.append("participante_oid", participanteSeleccionado);
      data.append("tipo_novedad", tipoNovedad);
      data.append("observacion", observacion);
      data.append("usuario", userLogin);
      data.append("estado", estado ?? '1');
      data.append("fecha_registro", fecha_registro);
      data.append("cedula", participanteCedula);
      data.append("participante_remplazo", participanteReemplazo ?? '');
      data.append("estado_remplazo", estado_remplazo);

      // --- Soportes principales (soporte=1) ---
      if (Array.isArray(soportes)) {
        soportes.forEach((soporte, index) => {
          if (soporte.archivo) {
            data.append("soportes", soporte.archivo);
            data.append(`estado_${index}`, soporte.estado ?? '1');
            data.append(`soporte_tipo_${index}`, '1');  // <--- soporte = 1
          }
        });
      }

      // --- Soportes de reemplazo (soporte=2) ---
      if (Array.isArray(soportesReemplazo)) {
        soportesReemplazo.forEach((soporte, index) => {
          if (soporte.archivo) {
            const idx = (soportes?.length ?? 0) + index; // para no chocar índices
            data.append("soportes", soporte.archivo);
            data.append(`estado_${idx}`, soporte.estado ?? '1');
            data.append(`soporte_tipo_${idx}`, '2');  // <--- soporte = 2
          }
        });
      }
      await createNovedad(data);
      message.success("Novedad guardada exitosamente");
      refreshNovedades();
      return true;
    } catch (error) {
      console.error("Error al guardar novedad:", error);
      message.error("Hubo un error al guardar la novedad");
      return false;
    }
  };

  const handleActualizar = async (formData, oid) => {
    try {
      await updateNovedad(oid, formData);
      message.success("Novedad actualizada correctamente");
      refreshNovedades();
      return true;
    } catch (error) {
      console.error("Error al actualizar:", error);
      message.error("Ocurrió un error al actualizar la novedad.");
      return false;
    }
  };

  useEffect(() => {
    aplicarFiltros();
  }, [filters, novedades]);

  return (
    <div className="container">
      <div className="row mb-2 d-flex align-items-center">
        <div className="col-md-7 linea_separador mb-2 d-flex align-items-center">
          <div className="titulo_proyecto" style={{ flexBasis: '25%', flexGrow: 0 }}>
            <p>PROYECTO UTF <br /> COL 160 COL</p>
          </div>
          <div className="objeto" style={{ flexBasis: '75%', flexGrow: 0 }}>
            <p>
              Implementar actividades de desarrollo económico, derecho humano a la alimentación y fortalecimiento de capacidades
              institucionales, comunitarias y organizacionales que aporten al cierre de brechas y la transformación de los territorios PDET
            </p>
          </div>
        </div>
        <div className="col-md-5 d-flex justify-content-center align-items-center flex-column">
          <h4 className="text-center mb-4">Novedades de Participantes</h4>

          <div className="d-flex flex-row gap-2">
            {permissionInsert && (
              <Button type="primary" onClick={() => setFormVisible(true)}>
                + Nueva Novedad
              </Button>
            )}
            {permissionExport && (
              <ExportExcelButton
                novedades={filteredNovedades}
                fileName="novedades_participantes"
              />
            )}
          </div>
        </div>

      </div>
      <FiltersComponentAntd
        filters={filters}
        opcionesFiltros={opcionesFiltros}
        totalRegistros={novedades.length}
        registrosFiltrados={filteredNovedades.length}
        onUpdateFilter={onUpdateFilter}
        onLimpiarFiltros={onLimpiarFiltros}
      />
      <NovedadesTable
        novedades={filteredNovedades}
        onEditar={handleEditar}
        onEliminar={handleEliminar}
        onVisualizar={handleVisualizar}
        canEdit={permissionUpdate}
        canDelete={permissionDelete}
        canView={permissionPrint}
      />
      <NovedadFormAntd
        open={formVisible}
        onOpenChange={setFormVisible}
        novedadEditando={novedadEditando}
        onGuardar={(formData) => guardarNovedad(formData)}
        onActualizar={(formData, oid) => handleActualizar(formData, oid)}
        onCancelar={() => {
          setNovedadEditando(null);
        }}
        departamentos={departamentos}
        municipios={municipios}
        participantes={novedadEditando ? listaPartiEditar || [] : participantes}
        userLogin={userLogin}
        onSuccess={fetchParticipantes}
        cargarParticipantes={fetchParticipantes}
      />
      <NovedadViewModal open={modalVisualizacion} onOpenChange={setModalVisualizacion} novedad={novedadVisualizando} />
    </div>
  );
};

export default NovedadesPage;
